module.exports = __webpack_public_path__ + "img/logo-ok.8e17b54c.png";